import { CSSProperties, MouseEventHandler, ReactNode, useRef } from 'react';

import { createPortal } from 'react-dom';

import { CSSTransition } from 'react-transition-group';
import { ExitHandler } from 'react-transition-group/Transition';
import { createGlobalStyle } from 'styled-components';

import { mask, maskAriaButton, maskContent } from './Mask.css';

const GlobalStyle = createGlobalStyle`
    html {
        overflow: hidden;
    }
`;

export interface MaskProps {
  visible?: boolean;
  children: ReactNode;
  style?: CSSProperties;
  onMaskClick?: MouseEventHandler<HTMLButtonElement>;
  onDestroyed?: ExitHandler<HTMLDivElement>;
}

export const Mask = (props: MaskProps) => {
  const { visible, children, onMaskClick, onDestroyed, style } = props;
  const nodeRef = useRef<HTMLDivElement>(null);
  const root = document.body;

  return createPortal(
    <CSSTransition
      nodeRef={nodeRef}
      in={visible}
      timeout={250}
      onExited={onDestroyed}
      classNames="mask"
      unmountOnExit
    >
      <div ref={nodeRef} className={mask} style={style}>
        <GlobalStyle />
        <button className={maskAriaButton} onClick={onMaskClick} />
        <div className={maskContent}>{children}</div>
      </div>
    </CSSTransition>,
    root,
  );
};
